var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.emailBadge},[_c('span',{class:_vm.$style.email,attrs:{"title":_vm.email}},[_vm._v("\n    "+_vm._s(_vm.email)+"\n  ")]),_vm._v(" "),_vm._t("badgeAction")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }